import React, { useState } from 'react';
import { Col, Form, FormInstance, Row, Button, Spin, ColProps } from 'antd';
import ParListSelect from 'components/ParListSelect';
import FormInput from 'components/FormInput';
import { getParList } from 'services/parametersService';
import ModalControllerNV from 'components/ModalControllerNV';
import AddAdresseValueModal from './AddAdresseValueModal';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { PlusOutlined } from '@ant-design/icons';
import { Icon } from '@ant-design/compatible';
import { CSSProperties } from 'styled-components';

export type AddressProps = {
  labelAlign?: 'right' | 'left';
  form: FormInstance;
  paysField?: string;
  regionGlobalField?: string;
  regionField?: string;
  villeField?: string;
  codePostalField?: string;
  colU?: number;
  spanZip?: number;
  spanRegion?: number;
  spanCity?: number;
  spanGlobalRegion?: number;
  spanCountry?: number;
  disabled?: boolean;
  hideRegionGlobal?: boolean;
  villeFirst?: any;
  regionFirst?: any;
  addValue?: boolean;
  countryRequired?: boolean;
  style?:CSSProperties
  styles?:CSSProperties
  Colw?:ColProps
};
const Address = ({
  addValue,
  spanZip,
  labelAlign,
  spanRegion,
  spanCity,
  spanGlobalRegion,
  spanCountry,
  colU,
  form,
  paysField = 'pays',
  regionGlobalField = 'regionGlobal',
  regionField = 'region',
  villeField = 'ville',
  codePostalField = 'codePostal',
  disabled = false,
  hideRegionGlobal = false,
  villeFirst,
  regionFirst,
  style,
  styles,
  countryRequired,
  Colw
}: AddressProps) => {
  const [isLoading, setIsLoading] = useState(false);

  const [refetchParlist, setRefetchParlist] = useState(false);
  const handlechangefrom = async (val: any, from: any) => {
    let value;
    setIsLoading(true);
    if (from === 'CITY') {
      await getParList({ parcode: from, tpid: 0 }).then(async (res) => {
        setIsLoading(false);

        value = res?.list?.find((ele) => ele.parvalue === val);

        if (value) {
          form.setFieldsValue({ [regionField]: value?.parvalueparent });
          await handlechangefrom(value?.parvalueparent, 'TPREGION');
        }
      });
    } else if (from === 'TPREGION') {
      await getParList({ parcode: from, tpid: 0 }).then(async (res) => {
        setIsLoading(false);

        value = res?.list?.find((ele) => ele.parvalue === val);
        if (value) {
          if (!villeFirst) {
            form.setFieldsValue({
              [regionGlobalField]: value?.parvalueparent,
            });
            await handlechangefrom(value?.parvalueparent, 'TPREGGLOB');
          } else {
            form.setFieldsValue({ [villeField]: value?.parvalueparent });
            await handlechangefrom(value?.parvalueparent, 'CITY');
          }
        }
      });
    } else if (from === 'ZIPCODE') {
      await getParList({ parcode: from, tpid: 0 }).then(async (res) => {
        setIsLoading(false);
        value = res?.list?.find((ele) => ele.parvalue === val);
        value && form.setFieldsValue({ [villeField]: value?.parvalueparent });
        await handlechangefrom(value?.parvalueparent, 'CITY');
      });
    } else if (from === 'TPREGGLOB') {
      await getParList({ parcode: from, tpid: 0 }).then((res) => {
        setIsLoading(false);

        value = res?.list?.find((ele) => ele.parvalue === val);
        if (value) {
          form.setFieldsValue({
            [paysField]: value?.parvalueparent,
          });
        }
      });
    }
  };

  return (
    <Col span={24}>
      <Spin
        spinning={isLoading}
        indicator={<Icon type="loading-3-quarters" spin />}
      >
        <Row gutter={16}>
          <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) => (
              <FormInput
                col
                xs={spanZip ? spanZip : colU ? colU : 4}
                labelAlign={labelAlign ?? 'right'}
                name={codePostalField}
                labelCol={Colw}
                style={styles?{marginBottom:'30px'}:{}}
              >
                <ParListSelect
                  parcode="ZIPCODE"
                  searchByLabelAndValue
                  refetchProps={refetchParlist}
                  disabled={disabled}
                  parvalueparent={
                    getFieldValue(villeField) !== ''
                      ? getFieldValue(villeField)
                      : (undefined as any)
                  }
                  onSelected={(val) => {
                    form.setFieldsValue({
                      [paysField]: '',
                      [villeField]: '',
                      [regionGlobalField]: '',
                      [regionField]: '',
                    });
                    handlechangefrom(val, 'ZIPCODE');
                  }}
                  allowClear
                  onClear={() => {
                    form.setFieldsValue({
                      [paysField]: '',
                      [villeField]: '',
                      [regionGlobalField]: '',
                      [regionField]: '',
                    });
                  }}
                />
              </FormInput>
            )}
          </Form.Item>
            {addValue && (
              <ModalControllerNV
                content={({ setVisible, visible }) => (
                  <Button
                    icon={<PlusOutlined />}
                    onClick={() => setVisible(true)}
                    size="middle"
                    style={style}
                  />
                )}
                modal={({ setVisible, visible }) => (
                  <AddAdresseValueModal
                    ParcodeParent="CITY"
                    parentname={villeField}
                    parvalueParent={form.getFieldValue(villeField)}
                    visible={visible}
                    onCancel={() => {
                      setRefetchParlist(!refetchParlist);
                      setVisible(false);
                    }}
                    onSuccess={() => {
                      setRefetchParlist(!refetchParlist);
                      setVisible(false);
                    }}
                    title={<GetLabel label="addZipCode" />}
                    refetched={false}
                    setrefetched={undefined}
                    parcode="ZIPCODE"
                  />
                )}
              ></ModalControllerNV>
            )}
          <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) => (
              <FormInput
                labelAlign={labelAlign ?? 'right'}
                col
                xs={spanCity ? spanCity : colU ? colU : 4}
                name={villeField}
                labelCol={Colw}
                style={styles?{marginBottom:'30px'}:{}}
              >
                <ParListSelect
                  parcode="CITY"
                  searchByLabelAndValue
                  disabled={disabled}
                  refetchProps={refetchParlist}
                  parvalueparent={
                    getFieldValue(regionField) !== ''
                      ? getFieldValue(regionField)
                      : (undefined as any)
                  }
                  onSelected={(val) => {
                    form.setFieldsValue({
                      [codePostalField]: '',
                    });
                    handlechangefrom(val, 'CITY');
                  }}
                  allowClear
                />
              </FormInput>
            )}
          </Form.Item>
            {addValue && (
              <ModalControllerNV
                content={({ setVisible, visible }) => (
                  <Button
                    icon={<PlusOutlined />}
                    onClick={() => setVisible(true)}
                    size="middle"
                    style={style}
                  />
                )}
                modal={({ setVisible, visible }) => (
                  <AddAdresseValueModal
                    ParcodeParent="TPREGION"
                    parentname={regionField}
                    parvalueParent={form.getFieldValue(regionField)}
                    visible={visible}
                    onCancel={() => {
                      setRefetchParlist(!refetchParlist);
                      setVisible(false);
                    }}
                    onSuccess={() => {
                      setRefetchParlist(!refetchParlist);
                      setVisible(false);
                    }}
                    title={<GetLabel label="addCity" />}
                    refetched={false}
                    setrefetched={undefined}
                    parcode="CITY"
                  />
                )}
              ></ModalControllerNV>
            )}
          <Form.Item shouldUpdate noStyle>
            {({ getFieldValue }) => (
              <FormInput
                labelAlign={labelAlign ?? 'right'}
                col
                xs={spanRegion ? spanRegion : colU ? colU : 4}
                name={regionField}
                labelCol={Colw}
                style={styles?{marginBottom:'30px'}:{}}
              >
                <ParListSelect
                  parcode="TPREGION"
                  disabled={disabled}
                  refetchProps={refetchParlist}
                  parvalueparent={
                    !villeFirst
                      ? getFieldValue(regionGlobalField) !== ''
                        ? getFieldValue(regionGlobalField)
                        : (undefined as any)
                      : getFieldValue(villeField) !== ''
                      ? getFieldValue(villeField)
                      : (undefined as any)
                  }
                  onSelected={(val) => {
                    form.setFieldsValue({
                      [codePostalField]: '',
                      [villeField]: '',
                    });
                    handlechangefrom(val, 'TPREGION');
                  }}
                  allowClear
                />
              </FormInput>
            )}
          </Form.Item>
          {addValue && (
            <ModalControllerNV
              content={({ setVisible, visible }) => (
                <Button
                  icon={<PlusOutlined />}
                  onClick={() => setVisible(true)}
                  size="middle"
                  style={style}
                />
              )}
              modal={({ setVisible, visible }) => (
                <AddAdresseValueModal
                  ParcodeParent="TPREGGLOB"
                  parentname={regionGlobalField}
                  parvalueParent={form.getFieldValue(regionGlobalField)}
                  visible={visible}
                  onCancel={() => {
                    setRefetchParlist(!refetchParlist);
                    setVisible(false);
                  }}
                  onSuccess={() => {
                    setRefetchParlist(!refetchParlist);
                    setVisible(false);
                  }}
                  title={<GetLabel label="addRegion" />}
                  refetched={false}
                  setrefetched={undefined}
                  parcode="TPREGION"
                />
              )}
            ></ModalControllerNV>
          )}
          {!hideRegionGlobal && (
            <>
              <Form.Item shouldUpdate noStyle>
                {({ getFieldValue }) => (
                  <FormInput
                    labelAlign={labelAlign ?? 'right'}
                    col
                    xs={spanGlobalRegion ? spanGlobalRegion : colU ? colU : 4}
                    name={regionGlobalField}
                    labelCol={Colw}
                    style={styles?{marginBottom:'30px'}:{}}
                  >
                    <ParListSelect
                      parcode="TPREGGLOB"
                      refetchProps={refetchParlist}
                      disabled={disabled}
                      parvalueparent={
                        !regionFirst
                          ? getFieldValue(paysField) !== ''
                            ? getFieldValue(paysField)
                            : (undefined as any)
                          : getFieldValue(regionField) !== ''
                          ? getFieldValue(regionField)
                          : (undefined as any)
                      }
                      onChange={(val) => {
                        form.setFieldsValue({
                          [codePostalField]: '',
                          [villeField]: '',
                        });
                        handlechangefrom(val, 'TPREGGLOB');
                      }}
                      allowClear
                    />
                  </FormInput>
                )}
              </Form.Item>

              {addValue && (
                <ModalControllerNV
                  content={({ setVisible, visible }) => (
                    <Button
                      icon={<PlusOutlined />}
                      onClick={() => setVisible(true)}
                      size="middle"
                      style={style}
                    />
                  )}
                  modal={({ setVisible, visible }) => (
                    <AddAdresseValueModal
                      ParcodeParent="COUNTRY"
                      parentname={paysField}
                      parvalueParent={form.getFieldValue(paysField)}
                      visible={visible}
                      onCancel={() => {
                        setRefetchParlist(!refetchParlist);
                        setVisible(false);
                      }}
                      onSuccess={() => {
                        setRefetchParlist(!refetchParlist);
                        setVisible(false);
                      }}
                      title={<GetLabel label="addGlobalRegion" />}
                      refetched={false}
                      setrefetched={undefined}
                      parcode="TPREGGLOB"
                    />
                  )}
                ></ModalControllerNV>
              )}
            </>
          )}
          <FormInput
            labelAlign={labelAlign ?? 'right'}
            col
            xs={spanCountry ? spanCountry : colU ? colU : 4}
            name={paysField}
            rules={[{ required: countryRequired ?? false }]}
            labelCol={Colw}
            style={styles?{marginBottom:'30px'}:{}}
          >
            <ParListSelect
              parcode="COUNTRY"
              refetchProps={refetchParlist}
              disabled={disabled}
              onSelected={() => {
                form.setFieldsValue({
                  [codePostalField]: '',
                  [villeField]: '',
                  [regionGlobalField]: '',
                  [regionField]: '',
                });
              }}
              allowClear
            />
          </FormInput>
          {addValue && (
            <ModalControllerNV
              content={({ setVisible, visible }) => (
                <Button
                  icon={<PlusOutlined />}
                  onClick={() => setVisible(true)}
                  size="middle"
                  style={style}
                />
              )}
              modal={({ setVisible, visible }) => (
                <AddAdresseValueModal
                  ParcodeParent=""
                  visible={visible}
                  onCancel={() => {
                    setRefetchParlist(!refetchParlist);
                    setVisible(false);
                  }}
                  onSuccess={() => {
                    setRefetchParlist(!refetchParlist);
                    setVisible(false);
                  }}
                  title={<GetLabel label="addCountry" />}
                  refetched={false}
                  setrefetched={undefined}
                  parcode="COUNTRY"
                />
              )}
            ></ModalControllerNV>
          )}
        </Row>
      </Spin>
    </Col>
  );
};

export default Address;
